/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';

import { Box } from '@atlaskit/primitives/compiled';

import { SectionName } from '../../../../common/analytics/section-name';
import { useSectionReveal } from '../../../../common/analytics/useSectionReveal';
import { SentryErrorBoundary } from '../../../../common/sentry';
import { Footer } from '../../../components/Footer';
import { HeroIcons } from '../../../components/InteractiveHeroIcons';
import { ConnectorShowcaseSection } from '../../../components/Sections/ConnectorShowcaseSection';
import { GettingStartedSection } from '../../../components/Sections/GettingStartedSection';
import { OverviewSection } from '../../../components/Sections/OverviewSection';

const styles = cssMap({
	pageContainer: {
		// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
		backgroundColor: '#111213',
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		minHeight: '100vh',
		WebkitFontSmoothing: 'antialiased',
		MozOsxFontSmoothing: 'grayscale',
	},
	heroSection: {
		position: 'relative',
		width: '100%',
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'flex-start',
		overflow: 'hidden',
	},
});

const HeroSection = (): JSX.Element => {
	const sectionRef = useSectionReveal<HTMLDivElement>(SectionName.Hero);
	return (
		<div ref={sectionRef} css={styles.heroSection}>
			<HeroIcons />
		</div>
	);
};

export const LoggedOutView = (): JSX.Element => {
	return (
		<div css={styles.pageContainer}>
			<HeroSection />
			<SentryErrorBoundary
				// TODO: GRAPHYTE-2509 Error fallback / Suspense Fallback
				// eslint-disable-next-line @atlassian/i18n/no-literal-string-in-jsx
				fallback={<Box>Issue with overview section</Box>}
				touchpointId="overview-section"
			>
				<OverviewSection />
			</SentryErrorBoundary>
			<ConnectorShowcaseSection />
			<GettingStartedSection />
			<Footer />
		</div>
	);
};
